import { render, staticRenderFns } from "./Catamnesis.vue?vue&type=template&id=4cdb2561"
import script from "./Catamnesis.vue?vue&type=script&lang=js"
export * from "./Catamnesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports